import { SuiteManifest, SuiteNavItem } from './manifest';
import { coreSuite } from './core';
import lmsManifest from './lms';
import sisManifest from './sis';
import schedulingManifest from './scheduling';
import feesManifest from './fees';
import crmManifest from './crm';
import communicationManifest from './communication';
import hrManifest from './hr';
import operationsManifest from './operations';
import biManifest from './bi';
import platformManifest from './platform';
import webbuilderManifest from './webbuilder';

export const allSuites: SuiteManifest[] = [
  coreSuite,
  lmsManifest,
  sisManifest,
  schedulingManifest,
  feesManifest,
  crmManifest,
  communicationManifest,
  hrManifest,
  operationsManifest,
  biManifest,
  platformManifest,
  webbuilderManifest,
];

export function getSuiteById(id: string): SuiteManifest | undefined {
  return allSuites.find((s) => s.id === id);
}

export function getAllSuites(): SuiteManifest[] {
  return allSuites;
}

export interface SuiteAccessAuth {
  role?: string;
  enabledSuites?: string[];
  hasPermission: (perm: string) => boolean;
  hasModule?: (suiteId: string, moduleId?: string) => boolean;
}

export function canUserAccessSuite(suite: SuiteManifest, auth: SuiteAccessAuth): boolean {
  if (suite.id === 'core') return true;
  if (auth.enabledSuites && auth.enabledSuites.length > 0 && !auth.enabledSuites.includes(suite.id)) {
    return false;
  }
  if (suite.allowedRoles && auth.role && !suite.allowedRoles.includes(auth.role)) {
    return false;
  }
  if (suite.requiredPermission && !auth.hasPermission(suite.requiredPermission)) {
    return false;
  }
  return true;
}

export function canUserAccessNavItem(
  item: SuiteNavItem,
  auth: SuiteAccessAuth,
  suiteId: string
): boolean {
  if (item.allowedRoles && auth.role && !item.allowedRoles.includes(auth.role)) {
    return false;
  }
  if (item.moduleId && auth.hasModule && !auth.hasModule(suiteId, item.moduleId)) {
    return false;
  }
  if (item.permission && !auth.hasPermission(item.permission)) {
    return false;
  }
  return true;
}

